/**
 * Class description
 *
 * Created: 2018-04-24
 * @author jonas
 */

import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {Ease, Linear, TimelineLite, TweenLite} from "gsap";
import {Currency} from "@nolimitcity/slot-game/bin/core/balance/Currency";

export class BasicBitmapCountUp extends PIXI.Container {
    public currentCountValue:number;     //Used by greensock. Don't change
    protected readonly _amountText:PIXI.BitmapText;
    private readonly _maxWidth:number | undefined;
    private _anchor:PIXI.Point;
    private _activeAnimation:TimelineLite | null;
    private _prevValue:number;
    private _pareCalculatedScale:boolean;


    constructor(style:BitmapTextStyleOptions, maxWidth?:number, anchor?:PIXI.Point) {
        super();
        this._maxWidth = maxWidth;
        this._anchor = anchor ? anchor : new PIXI.Point(0.5, 0.5);
        this._amountText = new PIXI.BitmapText("0000000", {
            fontName:style.font.name!,
            fontSize:style.font.size,
            align:style.align,
            tint:style.tint || 0xffffff
        });
        this.addChild(this._amountText);
    }

    public stopAt(amount:number, playSound:boolean = true) {
        if(this._activeAnimation != null && this._activeAnimation.isActive()) {
            this._activeAnimation.pause();
            this._activeAnimation.kill();
            this._activeAnimation = null;
        }
        this.currentCountValue = amount;
        this._prevValue = amount;
        this.setAmount(amount);
    }

    public preCalculateScale(from:number, to:number):void {
        this.setScaleToFitMaxWidth(from, to);
        this._pareCalculatedScale = true;
    }

    public getCountAnimation(from:number, to:number, duration:number, ease:Ease = Linear.easeNone):TimelineLite {
        if(duration == 0) {
            const tl:TimelineLite = new TimelineLite();
           if(!this._pareCalculatedScale) {
                tl.add(() => this.setScaleToFitMaxWidth(from, to));
            }
            tl.add(() => this.stopAt(to));
            return tl;
        }


        const tl:TimelineLite = new TimelineLite({onUpdate : () => this.updateText()});
        tl.add(() => this.stopAt(from, true));
        tl.add(() => this._activeAnimation = tl);

/*        if(!this._pareCalculatedScale) {
            tl.add(() => this.setScaleToFitMaxWidth(from, to));
        }*/

        tl.add(() => this.updateTextLayout());
        tl.add(new TweenLite(this, duration, {currentCountValue : to, ease : ease}));

        this._pareCalculatedScale = false;
        return tl;
    }

    protected updateText() {
        if(this.currentCountValue - this._prevValue > 0.01) {
            this.setAmount(this.currentCountValue);
            this._prevValue = this.currentCountValue;
        }
    }

    protected setAmount(value:number) {
        const newString = Currency.formatValue(value);
        if(newString.length != this._amountText.text.length) {
            this._amountText.text = newString;
            this.updateTextLayout();
        }
        else {
            this._amountText.text = newString;
        }
    }

    protected updateTextLayout() {
       this._amountText.position.set(-this._amountText.width * this._anchor.x, -this._amountText.height * this._anchor.y)
        //this._amountText.position.set(0, 0);
    }

    protected setScaleToFitMaxWidth(from:number, to:number):void {
        let textScale = 1;
        if(this._maxWidth != undefined) {
            this._amountText.scale.set(1);
            this.setAmount(to);
            textScale = Math.min(this._maxWidth / this._amountText.width, 1);
            this.setAmount(from);
        }
        this._amountText.scale.set(textScale);
    }
}